import * as Sentry from "@sentry/react";

function ErrorFallback() {
  return (
    <main role="alert" className="min-h-screen flex flex-col items-center justify-center gap-4 p-6 text-center">
      <h1 className="text-2xl font-semibold">Something went wrong</h1>
      <p>Reload the page to try again. If the problem continues, please contact support.</p>
      <button type="button" className="rounded bg-slate-900 px-4 py-2 text-white" onClick={() => window.location.reload()}>
        Reload page
      </button>
    </main>
  );
}

export default function ApplicationErrorBoundary({ children }) {
  return <Sentry.ErrorBoundary fallback={<ErrorFallback />}>{children}</Sentry.ErrorBoundary>;
}
